import React from 'react';
import { StatusBadge } from '../Shared/StatusBadge/StatusBadge';
import type { StatusBadgeVariant } from '../Shared/StatusBadge/StatusBadge';

interface CategoryPillProps {
  categoryKey: string;
  categoryName: string;
}

const CATEGORY_VARIANTS: Record<string, StatusBadgeVariant> = {
  salah: 'info',
  tahara: 'warning',
};

export const CategoryPill: React.FC<CategoryPillProps> = ({
  categoryKey,
  categoryName,
}) => {
  const variant = CATEGORY_VARIANTS[categoryKey] ?? 'neutral';
  return <StatusBadge variant={variant}>{categoryName}</StatusBadge>;
};
